import React from 'react';
import Icon from 'components/AppIcon';

const FeaturesSection = () => {
  const features = [
  {
    id: 1,
    icon: "MapPin",
    title: "Matching Geografico",
    description: "Ti collega a chi hai vicino. Meno strada da fare, più tempo per lavorare."
  },
  {
    id: 2,
    icon: "Clock",
    title: "Risparmio di Tempo",
    description: "Trova opportunità di lavoro nelle immediate vicinanze e dedica più tempo al lavoro effettivo invece che agli spostamenti."
  },
  {
    id: 3,
    icon: "Bell",
    title: "Notifiche Immediate",
    description: "Nuova richiesta nella tua zona? Lo sai subito, sulla web app o per mail. Senza perderci tempo."
  },
  {
    id: 4,
    icon: "Users",
    title: "Rete Locale",
    description: "Costruisci relazioni durature con clienti locali e diventa il professionista di riferimento nella tua area."
  },
  {
    id: 5,
    icon: "TrendingUp",
    title: "Crescita del fatturato",
    description: "Aumento del fatturato grazie alla tua posizione, puoi diventare il punto di riferimento del tuo settore nella tua zona"
  },
  {
    id: 6,
    icon: "Shield",
    title: "Profili Verificati",
    description: "I professionisti iscritti verranno verificati a livello documentale al fine di garantire la qualità dei servizi erogati."
  }];


  return (
    <section className="w-full bg-background py-12 md:py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex flex-col gap-8 md:gap-10 lg:gap-12">
          {/* Section Header */}
          <div className="flex flex-col gap-3 md:gap-4 text-center max-w-3xl mx-auto">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#013776]">Perché Scegliere Volaptic

            </h2>
            <p className="text-base md:text-lg text-muted-foreground">Una piattaforma nata per metterti in contatto con i professionisti vicino a te.

            </p>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7 lg:gap-8">
            {features?.map((feature) =>
            <div
              key={feature?.id}
              className="card hover:shadow-elevation-md transition-all duration-250 group">

                <div className="flex flex-col gap-4 md:gap-5">
                  <div className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 bg-primary/10 rounded-xl flex items-center justify-center group-hover:bg-primary/20 transition-all duration-250">
                    <Icon
                    name={feature?.icon}
                    size={28}
                    color="var(--color-primary)"
                    strokeWidth={2} />

                  </div>
                  <div className="flex flex-col gap-2 md:gap-3">
                    <h3 className="text-lg md:text-xl font-semibold text-foreground">
                      {feature?.title}
                    </h3>
                    <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                      {feature?.description}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>);

};

export default FeaturesSection;